import { cn } from "@/lib/utils";
import { amountText, round3 } from "@/lib/format";
import { RialSign } from "@/components/RialSign";

export const Money = ({ value, profit = false, className, ...rest }) => {
  const v = round3(value);
  const tone = v < 0 ? "text-red-600" : profit && v > 0 ? "text-green-600" : "";
  return (
    <span className={cn("num inline-flex items-baseline whitespace-nowrap", tone, className)} {...rest}>
      {v < 0 && "−"}<RialSign />{amountText(v)}
    </span>
  );
};

export const moneyNode = (v) => <Money value={v} />;
